import CustomHeader from "component/CustomHeader";
import { Button } from "component/ui/Button";
import React from "react";
import { Link } from "react-router-dom";
import { Drawer } from "component/ui/Drawer";
import FInanceAnalytics from "component/finance/FInanceAnalytics";
import FinanceDrawer from "component/finance/FinanceDrawer";
import TransferSuccessModal from "component/pay/TransferSuccessModal";
import PinModal from "component/pay/PinModal";
import MakePayModal from "component/flex/invoice/modal/MakePayModal";
import { toast } from "react-toastify";
import AddPaymentDetailsModal from "component/flex/invoice/modal/AddPaymentDetailsModal";
import ConfirmAccountDetails from "component/flex/invoice/modal/ConfirmAccountDetails";
import { PaymentOptions } from "constants/FinanceConstants";
import FInanceLoanAndPayment from "./FInanceLoanAndPayment";
import LoanDocumentSection from "./LoanDocumentSection";
import DeleteFinanceModal from "component/flex/shipments/modals/DeleteFinanceModal";
import GenerateStatementModal from "component/wallet/GenerateStatementModal";
import SuccessModal from "component/SuccessModal";
import successIcon from "asset/icons/SuccessCurrencyConversion.svg";
import { paymentStatusEnums } from "./ManageFinance";

const FinanceDetails = ({ data }) => {
  const {
    activeTab,
    setActiveTab,
    setActiveSubTab,
    subListFilter,
    activeSubTab,
    isLoadingAllFinancePayData,
    isLoadingFinanceGroup,
    isCancelingFinanceLoading,
    IsEmptyFinanceGroupList,
    financeGroupList,
    currency,
    navigate,
    handleCancelFinance,
    handleMakePayModal,
    handleMakeRepaymentModal,
    allFinancePayList,
    setFinanceDetails,
    deleteFinance,
    open,
    setOpen,
    isBusinessApproved,
    businessId,
    walletBalance,
    creditWalletBalance,
    creditWalletId,
    handleGenerateStatement,
    setShowDeleteModal,
    isLoadingBusinessDocsList,
    docList,
    financeDetails,
    showGenerateModal,
    setShowGenerateModal,
    currentBalance,
    user,
    setOnPinSuccess,
    onPinSuccess,
    setShowPinModal,
    showPinModal,
    isDownloading,
    pinError,
    setPinError,
    makePaymentModal,
    setMakePaymentModal,
    contractEmployer,
    setContractEmployer,
    selectedInvoice,
    setSelectedInvoice,
    paymentMethod,
    setPaymentMethod,
    amount,
    setAmount,
    transactionDocument,
    setTransactionDocument,
    freightDocument,
    setFreightDocument,
    otherDocument,
    setOtherDocument,
    invoiceUrl,
    setInvoiceUrl,
    purchaseOrderUrl,
    setPurchaseOrderUrl,
    makeARepayment,
    setMakeARepayment,
    repaymentData,
    repayFinanceLoading,
    handleRepayFinanceFunc,
    showOtp,
    setShowOtp,
    paymentType,
    setShowSuccessModal,
    generatedData,
    setGeneratedData,
    setPaymentType,
    setPayFull,
    setShowAddDetails,
    payFull,
    accountName,
    setAccountName,
    accountNumber,
    setAccountNumber,
    selectedBank,
    setSelectedBank,
    showAddDetails,
    defaultState,
    bankContractEmployer,
    setBankContractEmployer,
    walletBallanceId,
    handleCreateFinancePay,
    showConfirmDetails,
    setShowConfirmDetails,
    showSuccessModal,
    reason,
    setReason,
    showDeleteModal,
    network,
    setNetwork,
    uniqueWallet,
    setUniqueWallet,
    walletTouched,
    setWalletTouched,
  } = data;
  const amountToPay =
    repaymentData?.loans?.find((item) => item?.paymentStatus === paymentStatusEnums?.UNPAID)
      ?.amount || financeDetails?.totalAmount;
  const totalAmountToPay = repaymentData?.loans
    ?.filter((item) => item?.paymentStatus === paymentStatusEnums?.UNPAID)
    .reduce((acc, cur) => (acc += cur?.amount), 0);
  return (
    <>
      <Drawer direction="right" open={open} onOpenChange={setOpen}>
        <CustomHeader title={"Credit"}>
          <Button
            disabled={!isBusinessApproved}
            onClick={handleMakePayModal}
            variant="ghost"
            className="fourth-step"
          >
            Make a payment
          </Button>
          <Link
            to={isBusinessApproved ? "/finance/credit/request" : "#"}
            className={`hover:opacity-90 second-step bg-[#6F00FF] mt-0 sm:!mt-0 flex items-center gap-2 text-white rounded-lg py-[10px] px-3 md:!px-5 text-sm`}
          >
            <span>Request loan</span>
          </Link>
        </CustomHeader>

        <FInanceAnalytics
          businessId={businessId}
          makePaymentFunc={handleMakePayModal}
          handleGenerateStatement={handleGenerateStatement}
        />

        <div className="flex flex-col w-full gap-6 mt-6 md:flex-row">
          <FInanceLoanAndPayment
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setActiveSubTab={setActiveSubTab}
            subListFilter={subListFilter}
            activeSubTab={activeSubTab}
            isLoadingAllFinancePayData={isLoadingAllFinancePayData}
            isLoadingFinanceGroup={isLoadingFinanceGroup}
            isCancelingFinanceLoading={isCancelingFinanceLoading}
            IsEmptyFinanceGroupList={IsEmptyFinanceGroupList}
            financeGroupList={financeGroupList}
            currency={currency}
            openDrawer={() => setOpen(true)}
            navigate={navigate}
            handleCancelFinance={(id) => {
              setFinanceDetails({ id });
              setShowDeleteModal(true);
            }}
            handleMakePayModal={handleMakePayModal}
            handleMakeRepaymentModal={handleMakeRepaymentModal}
            allFinancePayList={allFinancePayList}
            setFinanceDetails={setFinanceDetails}
            deleteFinance={deleteFinance}
          />

          <LoanDocumentSection
            isLoadingBusinessDocsList={isLoadingBusinessDocsList}
            isCancelingFinanceLoading={isCancelingFinanceLoading}
            docList={docList}
            isBusinessApproved={isBusinessApproved}
          />
        </div>
        <FinanceDrawer
          financeDetails={financeDetails}
          setOpen={setOpen}
        />
      </Drawer>

      <GenerateStatementModal
        show={showGenerateModal}
        onClose={() => setShowGenerateModal(false)}
        wallet={currentBalance?.accountNumber}
        email={user?.email || ""}
        setShowPinModal={setShowPinModal}
        setOnPinSuccess={setOnPinSuccess}
        setShowSuccessModal={setShowSuccessModal}
        isForFinance={true}
        generatedData={generatedData}
        setGeneratedData={setGeneratedData}
      />
      {makeARepayment && (
        <MakePayModal
          currency={currency}
          walletBalance={walletBalance}
          onClick={() => {
            if (amount > walletBalance + creditWalletBalance) {
              return toast.error("Amount can not be greater than wallet balance");
            } else {
              setMakeARepayment(false);
              setShowOtp(true);
            }
          }}
          maxAmount={amountToPay || repaymentData?.requestedAmount}
          isLoading={repayFinanceLoading}
          isRepayment={true}
          show={makeARepayment}
          setShow={(value) => {
            setMakeARepayment(value);
          }}
          paymentType={paymentType}
          setPaymentType={setPaymentType}
          payFull={payFull}
          setPayFull={setPayFull}
          amount={amount}
          setAmount={setAmount}
          payFullAmount={totalAmountToPay}
        />
      )}

      {makePaymentModal && (
        <MakePayModal
          currency={currency}
          walletBalance={creditWalletBalance}
          onClick={() => {
            setMakePaymentModal(false);
            setShowAddDetails(true);
            // setShowConfirmDetails(true);
          }}
          contractEmployer={contractEmployer}
          setContractEmployer={setContractEmployer}
          selectedInvoice={selectedInvoice}
          setSelectedInvoice={setSelectedInvoice}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          show={makePaymentModal}
          setShow={setMakePaymentModal}
          amount={amount}
          setAmount={setAmount}
          isFinance={true}
          transactionDocument={transactionDocument}
          setTransactionDocument={setTransactionDocument}
          freightDocument={freightDocument}
          setFreightDocument={setFreightDocument}
          otherDocument={otherDocument}
          setOtherDocument={setOtherDocument}
          reason={reason}
          setReason={setReason}
          invoiceUrl={invoiceUrl}
          setInvoiceUrl={setInvoiceUrl}
          purchaseOrderUrl={purchaseOrderUrl}
          setPurchaseOrderUrl={setPurchaseOrderUrl}
          defaultState={defaultState}
        />
      )}
      <PinModal
        isInvoice
        isOpen={showOtp}
        goBack={() => {
          if (!repaymentData) {
            setShowAddDetails(true);
            setShowOtp(false);
          } else {
            setMakeARepayment(true);
            setShowOtp(false);
          }
        }}
        onClose={() => {
          setShowOtp(false);
          defaultState()
        }}
        onConfirm={async (data) => {
          const repayFunc = (loans) => {
            if (Array.isArray(loans)) {
              if (!payFull) {
                return [
                  loans?.find(
                    (item) => item?.paymentStatus === paymentStatusEnums.UNPAID
                  )?._id,
                ];
              } else {
                return loans
                  ?.map(
                    (item) =>
                      item?.paymentStatus === paymentStatusEnums.UNPAID &&
                      item?._id
                  )
                  ?.filter((item) => !!item);
              }
            } else {
              return [loans?._id];
            }
          };
          if (repaymentData) {
            const walletToUse = {
              "Credit Wallet": [creditWalletId],
              "Naira Wallet": [walletBallanceId],
              both: [creditWalletId, walletBallanceId],
            };
            const payload = {
              pin: data,
              subLoanIds: repayFunc(repaymentData?.loans),
              walletIds: walletToUse[paymentType],
            };
            await handleRepayFinanceFunc(payload);
          } else {
            handleCreateFinancePay(data);
          }
        }}
      />
      <PinModal
        isOpen={showPinModal}
        onClose={() => {
          setShowPinModal(false);
          setPinError("");
        }}
        onConfirm={async (enteredPin) => {
          setPinError("");
          if (onPinSuccess) {
            try {
              await onPinSuccess(enteredPin);
            } catch (err) {
              setPinError(err?.message || "Incorrect PIN. Please try again.");
              throw err;
            }
          }
        }}
        header="Enter your PIN to view statement"
        pinErrorMessage={pinError}
      />
      <AddPaymentDetailsModal
        accountName={accountName}
        setAccountName={setAccountName}
        accountNumber={accountNumber}
        setAccountNumber={setAccountNumber}
        selectedBank={selectedBank}
        setSelectedBank={setSelectedBank}
        show={showAddDetails}
        closeModal={() => {
          setShowAddDetails(false);
          defaultState();
        }}
        bankContractEmployer={bankContractEmployer}
        setBankContractEmployer={setBankContractEmployer}
        onSubmit={() => {
          setShowAddDetails(false);
          setShowOtp(true);
        }}
        isPoOrInvoice={
          paymentMethod === PaymentOptions[0] || paymentMethod === PaymentOptions[1]
        }
        network={network}
        setNetwork={setNetwork}
        uniqueWallet={uniqueWallet}
        setUniqueWallet={setUniqueWallet}
        walletTouched={walletTouched}
        setWalletTouched={setWalletTouched}
      />
      <ConfirmAccountDetails
        show={showConfirmDetails}
        closeModal={() => setShowConfirmDetails(false)}
        category={paymentMethod}
        onSubmit={() => {
          setShowConfirmDetails(false);
          setShowAddDetails(true);
        }}
      />
      <TransferSuccessModal />
      {showSuccessModal && (
        <SuccessModal
          show={true}
          onClose={() => setShowSuccessModal(false)}
          icon={
            <div className="p-1 rounded-full">
              <img src={successIcon} alt="success" className="w-24 h-24" />
            </div>
          }
          title="Your statement is ready!"
          message="We’ve sent a copy to your email."
          buttonText="Done"
          loading={isDownloading}
          onButtonClick={() => {
            setShowSuccessModal(false);
          }}
        />
      )}
      <div className="relative !z-[99999999]">
        <DeleteFinanceModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          reason={reason}
          setReason={setReason}
          onSubmit={async () => {
            await handleCancelFinance(financeDetails?.id);
          }}
          isLoading={isCancelingFinanceLoading}
        />
      </div>
    </>
  );
};

export default FinanceDetails;
